<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    width="Max(700px, 50vw)"
    transition="dialog-bottom-transition"
    :retain-focus="false"
  >
    <v-card class="fze-form">
      <v-card-title class="bg-main fs-14 px-4 py-0 text-white">
        Logged IN User
        <v-btn icon dark class="ml-auto" @click="cancel">
          <CrossIcon></CrossIcon>
        </v-btn>
      </v-card-title>

      <FunctionizeLoader v-if="loading" class="my-5"></FunctionizeLoader>

      <v-card-text v-else class="px-0">
        <v-simple-table height="50vh" fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Swap Login</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.email">
                <td>
                  <div class="py-1">
                    <span class="fs-14 font-weight-medium">{{ user.name }}</span>
                    <br />
                    <i>{{ user.email }}</i>
                  </div>
                </td>
                <td class="width-120 text-center">
                  <v-btn icon @click="confirm(user)">
                    <span class="mdi mdi-account text-main fs-24"></span>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FunctionizeLoader from "@/components/loader/FunctionizeLoader";
import CrossIcon from "@/assets/svg/crossIcon.svg";
import { mapState } from "vuex";

export default {
  name: "LoggedInUserDialog",
  components: { FunctionizeLoader, CrossIcon },
  props: {
    showDialog: {
      type: Boolean,
      require: true,
    },
  },
  data: () => ({
    loading: true,
    users: [],
  }),
  computed: {
    ...mapState({
      window: (state) => state.window,
    }),
  },
  methods: {
    swapUser(user) {
      const url = `/account/login/autologin?id=${user.user_id}&team_id=${user.team_id}&tempadmin=1`;

      const options = {
        CSRFToken: this.window.CSRFToken,
      };

      this.$http.post(url, this.formData(options)).then((response) => {
        if (response.data?.result === "loginsuccess") {
          window.location.replace("/sites/admin");
        } else {
          this.$toast.error(response.data.message || "Something went wrong");
          this.cancel();
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm(user) {
      const onSubmit = () => {
        this.$store.dispatch("commonDialog", { loading: true });
        this.swapUser(user);
      };

      this.$store.dispatch("commonDialog", {
        show: true,
        contentHTML: `<div> Login as ${user.name}</div>`,
        title: "Logged IN User",
        onSubmit: onSubmit,
        submitText: "Submit",
        cancelText: "Cancel",
        hideOnCancel: true,
      });
    },
  },
  created() {
    this.J_POST("/account/settings/getloggedinusercount?extradata=1")
      .then((data) => {
        this.users = data.response?.info || [];
      })
      .finally(() => {
        this.loading = false;
      });
  },
  watch: {
    showDialog(value) {
      this.syncBodyScroll(value);
    },
  },
};
</script>

<style scoped></style>
